import api from '../../../../utils/api';

const deleteIncomeSourceEmploymentDocumentPayslipOne = async (sourceId: string): Promise<unknown> => {
    return await api.deleteWithoutAuth(`api/screening/income-verification/${sourceId}/documents/employment/payslipOne/delete`);
}

export default deleteIncomeSourceEmploymentDocumentPayslipOne;
